import React from 'react';

import s from './vistaPlusPrescriptionTable.scss';

type PropsType = {
    odSph: string;
    osSph: string;
};

/**
 * Vista Plus prescription table
 * @param {PropsType} - od and os power values
 * @returns {React.ReactElement} - prescription table
 */
export const VistaPlusPrescriptionTable: React.FC<PropsType> = ({odSph, osSph}) => (
    <table className={s.table}>
        <thead>
            <tr className={s.row}>
                <th className={s.cell} />
                <th className={s.cell}>
                    <span className={s.header}>Power</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr className={s.row}>
                <td className={s.cell}>
                    <span className={s.header}>Right</span>
                    <span className={s.header}>(OD)</span>
                </td>
                <td className={s.cell}>{odSph}</td>
            </tr>
            <tr>
                <td className={s.cell}>
                    <span className={s.header}>Left</span>
                    <span className={s.header}>(OS)</span>
                </td>
                <td className={s.cell}>{osSph}</td>
            </tr>
        </tbody>
    </table>
);
